// Review setting
export const URL_GET_SURVEY_REVIEW = "/v1/gocheckin/review/gocheckin/list";
export const URL_CREATE_SURVEY_REVIEW = "/v1/gocheckin/review/gocheckin/create-content";
export const URL_DELETE_SURVEY_REVIEW = "/v1/gocheckin/review/gocheckin/delete-content?";
export const URL_UPDATE_SURVEY_REVIEW = "/v1/gocheckin/review/gocheckin/update-content?";
export const URL_ACTIVE_SURVEY_REVIEW = "/v1/gocheckin/review/gocheckin/active?";
export const URL_INACTIVE_SURVEY_REVIEW = "/v1/gocheckin/review/gocheckin/inactive?";
export const URL_GET_STAFF_RATING_ANSWER = "/v1/pos/setting/site/list-answer";
export const URL_CREATE_ANSWER = "/v1/pos/setting/form/create-answer";
export const URL_UPDATE_ANSWER = "/v1/pos/setting/form/update-answer";
export const URL_CHANGE_ANSWER_STATUS = "/v1/pos/setting/form/change-answer-status";

export const URL_GET_DEVICE_LIST = "/v1/pos/device/site/list";
export const URL_DELETE_DEVICE = "/v1/pos/device/site/delete";
export const URL_UPDATE_STAFF_RATING_DEVICE = "/v1/pos/device/site/update-staff-rating-device";



export const URL_GET_GOOGLE_REVIEW = "/v1/gocheckin/review/google-review/list";
export const URL_CREATE_GOOGLE_REVIEW = "/v1/gocheckin/review/google-review/create-content";
export const URL_DELETE_GOOGLE_REVIEW = "/v1/gocheckin/review/google-review/delete-content?";
export const URL_UPDATE_GOOGLE_REVIEW = "/v1/gocheckin/review/google-review/update-content?";
export const URL_ACTIVE_GOOGLE_REVIEW = "/v1/gocheckin/review/google-review/active?";
export const URL_INACTIVE_GOOGLE_REVIEW = "/v1/gocheckin/review/google-review/inactive?";


// Review List
export const URL_GET_REVIEW_LIST = "/v1/gocheckin/review/site/list?";
export const URL_GET_REVIEW_REPORT = "/v1/gocheckin/review/site/report";
// Review list new
// export const URL_GET_ALL_REVIEW_LIST = '/v1/gocheckin/review/site/get-all?';
// export const URL_GET_GOCHECKIN_REVIEW_LIST = '/v1/gocheckin/review/site/get-go-checkin?';
// export const URL_GET_YELP_REVIEW_LIST = '/v1/gocheckin/review/site/get-yelp?';
// export const URL_GET_GOOGLE_REVIEW_LIST = '/v1/gocheckin/review/site/get-google?';
// export const URL_SORT_ALL_REVIEW = '/v1/gocheckin/review/site/sort';
// export const URL_SEARCH_BY_NAME = '/v1/gocheckin/review/site/search';
export const URL_GET_SYSTEM_MESSAGE = '/v1/gocheckin/review/site/system-message?';
export const URL_REPLY_GOCHECKIN_REVIEW = '/v1/gocheckin/review/form/reply-go-checkin';
export const URL_REPLY_GOOGLE_REVIEW = '/v1/gocheckin/review/form/reply-google';
export const URL_UPDATE_GOOGLE_REPLY_REVIEW = '/v1/gocheckin/review/form/update-reply-google';
export const URL_DELETE_GOOGLE_REPLY_REVIEW = '/v1/gocheckin/review/form/delete-reply-google';
export const URL_CHECK_REVIEW_REPLY_PERMISSION = "/v1/gocheckin/review/site/check-reply-review-permission";

export const URL_GET_STAFF_RATING_LIST = '/v1/pos/rating/site/get-list-rating?';
